import broadcastMessage from './custom/broadcast-message'
import chatters from './resources/chatters/requests'
import messages from './resources/messages/requests'
import prompts from './resources/prompts/requests'
import webinars from './resources/webinars/requests'
import freeContent from './resources/free_content/requests'
import { auth } from './custom/auth'
import verifyChatter from './resources/chatters/verify'
import sendMessage from './custom/send-message'
import forceAction from './custom/force-action'
import uploadPhotos from './custom/upload-photos'
import assignShift from './custom/assign-shift'
import getCurators from './custom/get-curators'
import addIncomeImg from './custom/add-income-img'
import incomes from './resources/incomes.ts/requests'
import sendTest from './custom/send-test'
import getNudgedChatters from './custom/nudges/get-nudged-chatters'
import addNudge from './custom/nudges/add-nudge'
import getNudgeOutcomes from './custom/nudges/get-nudge-outcomes'
import { broadcastApi } from './custom/broadcast'
import { resendFirstTestApi } from './custom/resend-first-test'

export const api = {
  chatters,
  messages,
  prompts,
  webinars,
  freeContent,
  broadcastMessage,
  sendMessage,
  verifyChatter,
  auth,
  forceAction,
  uploadPhotos,
  assignShift,
  addIncomeImg,
  getCurators,
  incomes,
  sendTest,
  nudges: {
    getChatters: getNudgedChatters,
    getOutcomes: getNudgeOutcomes,
    add: addNudge,
  },
  broadcast: broadcastApi,
  resendFirstTest: resendFirstTestApi,
}
